import { NavMarker } from 'react-rhumb';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import DefaultErrorComponent from '../DefaultErrorComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingComponent = ({
  pastDelay
}) => pastDelay ? /*#__PURE__*/_jsx(UILoadingSpinner, {
  grow: true,
  layout: "centered"
}) : null;
const ErrorComponent = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "FILTERS_PANEL_ERROR"
    }), /*#__PURE__*/_jsx(DefaultErrorComponent, {})]
  });
};
const AdvancedFiltersAsync = Loadable({
  loader: () => import( /* webpackChunkName: "advanced-filters" */'./AdvancedFilters'),
  LoadingComponent,
  ErrorComponent
});
export default AdvancedFiltersAsync;